import React, { useEffect, useRef, useState } from "react";
import TradingViewChart from "./TradingViewChart.jsx";

const cap = (n) => {
  if (n == null) return "\u2014";
  n = Number(n);
  if (n >= 1000) return "$" + (n / 1000).toFixed(2) + "T";
  if (n >= 1) return "$" + n.toFixed(2) + "B";
  return "$" + (n * 1000).toFixed(0) + "M";
};

function LazyChart({ symbol }) {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") { setShow(true); return; }
    const io = new IntersectionObserver((es) => {
      if (es.some((e) => e.isIntersecting)) { setShow(true); io.disconnect(); }
    }, { rootMargin: "300px" });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return <div ref={ref} className="tc-chart">{show ? <TradingViewChart symbol={symbol} /> : null}</div>;
}

function Card({ c }) {
  const ch = c.change_1d == null ? null : Number(c.change_1d);
  return (
    <div className="card top-company-card">
      <div className="top-company-header">
        <a className="fw-bold wl-company" href={"#/stock/" + c.ticker}>{c.name}</a>
        <span className="text-muted small">{c.ticker}</span>
      </div>
      {(c.mcap != null || ch != null) && (
        <div className="tc-meta text-muted small">
          {c.mcap != null && <span>Market cap {cap(c.mcap)}</span>}
          {ch != null && (
            <span className={ch >= 0 ? "change-up" : "change-down"}>
              {c.mcap != null ? " \u00b7 " : ""}{ch >= 0 ? "+" : ""}{ch.toFixed(2)}% today
            </span>
          )}
        </div>
      )}
      <LazyChart symbol={c.symbol} />
    </div>
  );
}

export default function TopCompanies({ title, companies, limit = 3, scroll = false }) {
  const list = (companies || []).slice(0, limit);
  if (!list.length) return null;
  return (
    <section className="mb-5">
      <h5 className="fw-bold mb-3">{title}</h5>
      {scroll ? (
        <div className="tc-scroll">
          {list.map((c) => <div key={c.symbol} className="tc-item"><Card c={c} /></div>)}
        </div>
      ) : (
        <div className="row g-3">
          {list.map((c) => <div key={c.symbol} className="col-12 col-lg-4"><Card c={c} /></div>)}
        </div>
      )}
    </section>
  );
}